// 把存好的會議紀錄內容印出來。
//
// **這裡用了 `dangerouslySetInnerHTML`,而那是刻意的** —— 內容本來就是 HTML,
// 不這樣印就只能看到一堆標籤。安全靠的是**存進去之前**那一關:
// `backend/app/sanitize.py` 用 nh3 洗過白名單才寫進資料庫。
//
// 所以這個元件有一條不可以違反的規矩:
//
//     **只印從我們自己 API 讀回來的內容。**
//
// 要印使用者當下打的字(還沒存、沒洗過),請用純文字 —— 那一份沒有經過消毒。

export function RichText({ html, className = "" }: { html: string; className?: string }) {
  const text = (html || "").trim();
  if (!text) {
    return <p className="m-0 text-sm text-[var(--text-3)]">(沒有內容)</p>;
  }
  return (
    <div
      className={`nq-prose ${className}`}
      // eslint-disable-next-line react/no-danger -- 見檔頭:消毒在後端,這裡只負責印。
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
}
